import { MachineDto, ModalService, SimpleMessageService, Tenant, WebAppCommonModule } from '@allbesmart/web-app-common';
import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { TenantManagementService } from 'src/app/services/tenant-management.service';

@Component({
    selector: 'oaibox-unlink-machine-warning-modal',
    templateUrl: './unlink-machine-warning-modal.component.html',
    styleUrls: ['./unlink-machine-warning-modal.component.css'],
    imports: [WebAppCommonModule]
})
export class UnlinkMachineWarningModalComponent implements OnDestroy {

  @Input() public tenant?: Tenant;
  @Input() public machine?: MachineDto;

  private unlinkMachineSubscription?: Subscription;

  constructor(
    private simpleMessageService: SimpleMessageService,
    private tenantManagementService: TenantManagementService,
    private modalService: ModalService
  ) {
  }

  protected confirm(): void {
    if (this.tenant && this.machine) this.unlinkMachineSubscription = this.tenantManagementService
      .unlinkMachineFromTenant(this.tenant.id, this.machine.id).subscribe({
        next: () => {
          this.simpleMessageService.showSimpleMessage({
            message: 'Machine unlinked successfully!', icon: 'fa-solid fa-check-double', color: 'success'
          });
          this.tenantManagementService.refreshTenants();
          this.modalService.popModal();
        },
        error: () => {
          this.simpleMessageService.showSimpleMessage({
            message: 'Machine not unlinked!', icon: 'fa-solid fa-triangle-exclamation', color: 'danger'
          });
          this.modalService.popModal();
        },
      });
  }

  protected cancel(): void {
    this.modalService.popModal();
  }

  ngOnDestroy(): void {
    this.unlinkMachineSubscription?.unsubscribe();
  }

}
